import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconDropDownSmallArrow = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="7" height="4" viewBox="0 0 7 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.875 0.75L3.6875 3.25L6.5 0.75" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    </div>
);

export default IconDropDownSmallArrow;
